// Generated by ReScript, PLEASE EDIT WITH CARE


var sdkDomainUrl = sdkUrl + publicPath;

var apiEndPoint = {
  contents: undefined
};

function setApiEndPoint(str) {
  apiEndPoint.contents = str;
}

function getApiEndPoint(publishableKeyOpt, isConfirmCallOpt) {
  var publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  var isConfirmCall = isConfirmCallOpt !== undefined ? isConfirmCallOpt : false;
  var testMode = publishableKey.startsWith("pk_snd_");
  var str = apiEndPoint.contents;
  if (str !== undefined) {
    return str;
  }
  var backendEndPoint$1 = isConfirmCall ? confirmEndPoint : backendEndPoint;
  if (isProductionEnv && testMode) {
    return "https://beta.hyperswitch.io/api";
  } else {
    return backendEndPoint$1;
  }
}

function hyperswitchVaultEndPoint(publishableKeyOpt) {
  var publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  var testMode = publishableKey.startsWith("pk_snd_");
  if (isProductionEnv && !testMode) {
    return "https://checkout.hyperswitch.io/api";
  } else if (isIntegrationEnv) {
    return "https://dev.hyperswitch.io/api";
  } else {
    return "https://beta.hyperswitch.io/api";
  }
}

function getVaultEndPoint(publishableKeyOpt) {
  var publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  if (isPciCompliant || isLocal) {
    return getApiEndPoint(publishableKey, undefined);
  } else {
    return hyperswitchVaultEndPoint(publishableKey);
  }
}

var hyperswitchVaultSdkUrl = isProductionEnv ? "https://checkout.hyperswitch.io" : (
    isSandboxEnv ? "https://beta.hyperswitch.io" : "https://dev.hyperswitch.io"
  );

var vaultSdkDomainUrl = isPciCompliant || isLocal ? sdkDomainUrl : hyperswitchVaultSdkUrl + publicPath;

function addCustomPodHeader(arr, customPodUri) {
  if (customPodUri !== undefined && customPodUri !== "") {
    arr.push([
          "x-feature",
          customPodUri
        ]);
  }
  return Object.fromEntries(arr);
}

var switchToInteg = false;

var isLocal$1 = false;

export {
  switchToInteg ,
  isLocal$1 as isLocal,
  sdkDomainUrl ,
  apiEndPoint ,
  setApiEndPoint ,
  getApiEndPoint ,
  hyperswitchVaultEndPoint ,
  getVaultEndPoint ,
  hyperswitchVaultSdkUrl ,
  vaultSdkDomainUrl ,
  addCustomPodHeader ,
}
/* sdkDomainUrl Not a pure module */
